import {EnumInfo, EnumInfoMap} from "../../../declarations";

export type PaymentType = "CreditCard" | "DebitCard" | "ACH" | "ApplePay" | "GooglePay";

export type BankAccountType = "Unknown" | "PersonalChecking" | "PersonalSavings" | "BusinessChecking";

export const bankAccountTypeInfoMap: EnumInfoMap<BankAccountType> = new Map<BankAccountType, EnumInfo>([
  ["PersonalChecking", {labelKey: "Personal Checking"}],
  ["PersonalSavings", {labelKey: "Personal Savings"}],
  ["BusinessChecking", {labelKey: "Business Checking"}],
  ["Unknown", {labelKey: "Unknown"}],
]);

type ApplePayPaymentHeader = {
  applicationData: string;
  ephemeralPublicKey: string;
  publicKeyHash: string;
  transactionId: string;
};

type ApplePayPaymentData = {
  data: string;
  header: ApplePayPaymentHeader;
  signature: string;
  version: string;
};

type ApplePaymentMethod = {
  displayName: string;
  network: string;
  type: string;
};

type AppleToken = {
  paymentData: ApplePayPaymentData;
  paymentMethod: ApplePaymentMethod;
  transactionIdentifier: string;
};

// Payment detail types
export type PaymentApplePayDetails = {
  token: AppleToken;
};

export type PaymentGooglePayDetails = {
  placeholder: string;
};

export type PaymentAchDetails = {
  account_name: string;
  ABA: string;
  account_number: string;
  account_type: BankAccountType;
  zip_code: string;
  state: string;
};

export type PaymentCardDetails = {
  card_number: string;
  expiration_date: string;
  card_holder_name: string;
  cvv: string;
  address: string;
  zip_code: string;
};

export type PaymentDetails = {
  credit_card?: PaymentCardDetails;
  ach?: PaymentAchDetails;
  apple_pay?: PaymentApplePayDetails;
  google_pay?: PaymentGooglePayDetails;
  amount?: string;
  email?: string;
  terms_and_conditions?: boolean;
  is_prepaid?: boolean;
  ach_unlock_password?: string;
  applePayCompletionFunction?: (success: boolean) => void;
};
